export enum ChangeEmailPage { VerificationCode, UpdateEmailAddress, Success }
